export class EnquadradaModel {
    id: number;
    nome: string;
    cnpj: string;
}
